import {get} from 'lodash'
import axios from 'axios'

const baseURL = '/api/education/'
export default class Education {
	constructor (init) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}
	setDefaultData (init = {}) {
		if (!init) return
		this.id = get(init, 'id') ? init.id : null
		this.university = get(init, 'university') ? init.university : ''
	}

	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new Education(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	getSingle () {
		return axios.get(`${baseURL}${this.id}`)
			.then(res => {
				this.setDefaultData(res.data.data)
				return res
			})
	}
	get formData () {
		const formData = new FormData()

		formData.append('university', this.university)

		return formData
	}
	save () {
		let url
		if (this.id) {
			url = `${baseURL}${this.id}` // for update request
		}	else {
			url = `${baseURL}` // for create request
		}

		return axios.post(url, this.formData)
			.then(res => {
				this.setDefaultData(res.data.data)
				return res
			})
	}
	delete () {
		return axios.delete(`${baseURL}${this.id}`)
	}
}

export class EducationUser {
	constructor (init = {}) {
		this.id = get(init, 'id') ? init.id : null
		this.cathedra = get(init, 'cathedra') ? init.cathedra : ''
		this.faculty = get(init, 'faculty') ? init.faculty : ''
		this.form = get(init, 'form') ? init.form : ''
		this.releaseYear = get(init, 'releaseYear') ? init.releaseYear : null
		this.specialization = get(init, 'specialization') ? init.specialization : ''
		this.university_leader_id = get(init, 'university_leader_id') ? init.university_leader_id : null
		this.university = get(init, 'university') ? {
			id: this.id,
			university: init.university
		} : {
			id: null,
			university: ''
		}
		this.isCreate = get(init, 'isCreate') ? init.isCreate : false
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Education.class.js